export default __webpack_public_path__ + "static/media/antirfreeze.050ab64b.webp";